class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    this.index = 0;
    this.timer = null;
  }

  connectedCallback() {
    if (this.slides.length <= 1) return;

    const prev = this.querySelector('[data-hero-prev]');
    const next = this.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
    if (next) next.addEventListener('click', () => this.go(this.index + 1, true));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.heroDot, 10), true));
    });

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.dataset.autoplay === 'true' && !this.reduceMotion) {
      this.interval = parseInt(this.dataset.interval, 10) || 7000;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
  }

  disconnectedCallback() {
    this.stop();
  }

  go(target, userInitiated) {
    const count = this.slides.length;
    this.index = ((target % count) + count) % count;

    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    if (userInitiated && this.dataset.autoplay === 'true' && !this.reduceMotion) {
      this.start();
    }
  }

  start() {
    this.stop();
    if (this.dataset.autoplay !== 'true' || this.reduceMotion) return;
    this.timer = window.setInterval(() => this.go(this.index + 1, false), this.interval);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('hero-slider', HeroSlider);
